export default "__VITE_PUBLIC_ASSET__d018cb56__"